var _path, _path2, _rect, _circle, _circle2, _path3, _path4, _path5, _polygon, _polygon2, _polygon3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDesktops = function SvgDesktops(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "desktops",
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m434.63,384.69v-.41H27.26c135.64,1.14,272.03.1,407.37.41Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m565.84,161.48h-114.21c-1.37,0-2.7.18-3.98.49v222.31h-13.02v.41c3.94,0,7.89,0,11.82.02,2.11,14.13,2.44,31.4-11.82,36.82v36.79c0,9.39,7.61,17,17,17h114.21c9.39,0,17-7.61,17-17V178.48c0-9.39-7.61-17-17-17Zm-57.56,273.49c-10.03,0-18.16-8.13-18.16-18.16s8.13-18.16,18.16-18.16,18.16,8.13,18.16,18.16-8.13,18.16-18.16,18.16Zm-14.54-65.35c0-7.22,5.85-13.08,13.08-13.08s13.08,5.85,13.08,13.08-5.85,13.08-13.08,13.08-13.08-5.85-13.08-13.08Zm64.59-52.34c0,9.39-7.61,17-17,17h-65.2c-9.39,0-17-7.61-17-17v-115.91c0-9.39,7.61-17,17-17h65.2c9.39,0,17,7.61,17,17v115.91Z",
    fill: "#015e85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 459.14,
    y: 184.36,
    width: 99.2,
    height: 149.91,
    rx: 17,
    ry: 17,
    fill: "#f4abe0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 506.82,
    cy: 369.62,
    r: 13.08,
    fill: "#6ab4e5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.28,
    cy: 416.81,
    r: 18.16,
    transform: "translate(-89.95 144.42) rotate(-14.87)",
    fill: "#6ab4e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m446.45,384.71c-3.94-.01-7.88-.01-11.82-.02-135.34-.31-271.73.73-407.37-.41-1.47,12.67-3.34,29.87,9.96,36.92,44.28,4.87,90.11.27,134.9,1.79,6.25-.31,10.34-.38,12.96-.04l.09-.28h103.36l.16.35c.59-.02,1.27-.02,2.06-.02,45.77,0,91.54-.07,137.3.05,2.48-.26,4.65-.79,6.56-1.51,14.26-5.42,13.93-22.69,11.82-36.82Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m170.76,466.79l.18-.54h-18.26c-2.88,0-5.22,2.34-5.22,5.22s2.34,5.22,5.22,5.22h170.46c2.88,0,5.22-2.34,5.22-5.22s-2.34-5.22-5.22-5.22h-14.26l.25.54h-138.37Z",
    fill: "#6ab4e5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m447.65,384.28v-246.3c0-14.1-11.43-25.54-25.54-25.54H52.8c-14.1,0-25.54,11.43-25.54,25.54v246.3h420.39Zm-26.78-17.89H52.11v-229.6h368.76v229.6Z",
    fill: "#6e5f91"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "52.11 136.79 52.11 366.39 320.77 366.39 258.49 136.79 52.11 136.79",
    fill: "#f4abe0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.77 366.39 420.87 366.39 420.87 136.79 258.49 136.79 320.77 366.39",
    fill: "#ef6ba0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "185.18 422.67 185.09 422.95 170.94 466.25 170.76 466.79 309.13 466.79 308.88 466.25 288.7 423.02 288.54 422.67 185.18 422.67",
    fill: "#015e85"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDesktops, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/desktops.28799ee9.svg";
export { ForwardRef as ReactComponent };